import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-progress',
    imports: [],
    templateUrl: './progress.component.html',
    styleUrl: './progress.component.scss'
})
export class ProgressComponent {
  @Input() public value: number = 0;
}
